import Axios from '@/components/api/axios.js'
/**********************************************************************************
 * 所有维度iot平台的设备增删改接口都是这里,根据使用的模板不同有不同的serverInfo,根据情况选择
 **********************************************************************************/
export default {
	/**
	 * 创建设备,通讯设备/虚拟设备/变量/权限等都一次性创建的
	 */
	createDevice: (name, deviceCollectionType, deviceGroup, deviceTemplate, deviceSubseries, serverInfo, channelNo,
		groupNo, success, failure) => {
		Axios.post('/iot/createDevice.do', {
			name,
			deviceCollectionType,
			deviceGroup,
			deviceTemplate,
			deviceSubseries,
			serverInfo,
			channelNo,
			groupNo,
		}, success, failure);
	},
	/**
	 * 删除虚拟设备及其相关所有内容
	 */
	deleteDevice: (no, success,
		failure) => {
		Axios.post('/iot/deleteDevice.do', {
			no
		}, success, failure);
	},
	/**
	 * 更新设备信息
	 */
	updateDevice: (no, name, serverInfo, success,
		failure) => {
		Axios.post('/iot/updateDevice.do', {
			no,
			name,
			serverInfo
		}, success, failure);
	}
}
